// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__3iiLc","Home__Input":"Home_Home__Input__2J3JW"};